var _style, _g, _path, _polygon, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialitiesSectionArt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000039835526939424746230000001260946749667145094_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1466.9 1091.8",
    style: {
      enableBackground: "new 0 0 1466.9 1091.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC1A15;}\r\n\t.st1{fill:#FEEFE6;}\r\n\t.st2{fill:#D49BA0;}\r\n\t.st3{fill:none;stroke:#F2CDBF;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#F2CDBF;}\r\n\t.st5{fill:#D4A59B;}\r\n\t.st6{fill:#FADED2;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#F0D3D8;}\r\n\t.st9{fill:#A7C2D9;}\r\n\t.st10{fill:#BF828B;}\r\n\t.st11{fill:#326894;}\r\n\t.st12{fill:#4D8AB3;}\r\n\t.st13{fill:#994403;}\r\n\t.st14{fill:#852E03;}\r\n\t.st15{fill:#732D02;}\r\n\t.st16{fill:#EBF5FF;}\r\n\t.st17{fill:#FBBD9A;}\r\n\t.st18{fill:#F0997F;}\r\n\t.st19{fill:#D43226;}\r\n\t.st20{fill:#002A42;}\r\n\t.st21{fill:#EB4A2A;}\r\n\t.st22{fill:#06384F;}\r\n\t.st23{fill:none;stroke:#27788F;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st24{fill:#8C4206;}\r\n\t.st25{fill:#A66317;}\r\n\t.st26{fill:#2F344D;}\r\n\t.st27{fill:none;stroke:#8C4206;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st28{fill:none;stroke:#D45E4E;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st29{fill:#DE3B26;}\r\n\t.st30{fill:#163649;}\r\n\t.st31{fill:#B82621;}\r\n\t.st32{fill:#FBBD9A;stroke:#D45E4E;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st33{fill:none;stroke:#B82621;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st34{fill:#FDBD9B;}\r\n\t.st35{fill:none;stroke:#B0514A;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st36{fill:#316382;}\r\n\t.st37{fill:#407C91;}\r\n\t.st38{fill:#502202;}\r\n\t.st39{fill:#855321;}\r\n\t.st40{fill:#112C45;}\r\n\t.st41{fill:#163A4A;}\r\n\t.st42{fill:#4B8394;}\r\n\t.st43{fill:#6B4019;}\r\n\t.st44{fill:none;stroke:#502202;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st45{fill:none;stroke:#B0514A;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st46{fill:#2D3A5E;}\r\n\t.st47{fill:#69C5C9;}\r\n\t.st48{fill:none;stroke:#3E7C8A;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st49{fill:#9BEBE7;}\r\n\t.st50{fill:#DAE8F7;}\r\n\t.st51{fill:none;stroke:#B8C8E3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st52{fill:none;stroke:#163649;stroke-miterlimit:10;}\r\n\t.st53{fill:none;stroke:#163649;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st54{fill:#381B07;}\r\n\t.st55{fill:#DB8E62;}\r\n\t.st56{fill:#1D9FB3;}\r\n\t.st57{fill:#B23F37;}\r\n\t.st58{fill:#678CA8;}\r\n\t.st59{fill:#136D94;}\r\n\t.st60{fill:#CF6E4A;}\r\n\t.st61{fill:#25B2C2;}\r\n\t.st62{fill:#27B8C1;}\r\n\t.st63{fill:none;stroke:#51DBDB;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st64{fill:#D68A5A;}\r\n\t.st65{fill:#24151A;}\r\n\t.st66{fill:none;stroke:#A8473E;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st67{fill:#32C9CF;}\r\n\t.st68{fill:#412408;}\r\n\t.st69{fill:#664216;}\r\n\t.st70{fill:#411F00;}\r\n\t.st71{fill:none;stroke:#412408;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st72{fill:none;stroke:#A8473E;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st73{fill:#FFA8B1;}\r\n\t.st74{fill:#F2E4E5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,119.2c26,24.6,51.9,49.1,77.9,73.8c22.3-23.5,44.5-46.9,66.9-70.5c-11.8-11-23.6-22-35.6-33.3 c-1.8,1.9-3.5,3.8-5.3,5.5c-8.8,8.9-17.6,17.7-26.4,26.5c-3.9,3.9-9.4,4.1-13,0.4c-3.6-3.6-3.4-9.1,0.5-13 c12.4-12.4,24.7-24.9,37.1-37.3c4.4-4.4,9.3-4.5,13.7-0.3c15.7,14.7,31.4,29.3,47.1,44c4.3,4,4.5,9.3,0.5,13.6 c-26.2,27.6-52.3,55.2-78.5,82.8c-3.7,3.9-9,4-13,0.2c-14.7-13.9-29.3-27.8-44-41.6C34.2,155.7,19.1,141.4,4,127 c-5.1-4.9-5.3-9.7-0.4-14.8c27.9-29.5,55.8-58.9,83.7-88.4c3.5-3.7,7-4.8,10.7-3.3c6,2.3,7.6,9.7,3.2,14.5c-8,8.5-16,17-24.1,25.5 C59,79.5,41,98.5,23,117.6C22.5,118,22.1,118.5,21.5,119.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.9,118c-26-24.6-51.8-49.1-77.9-73.8c-22.3,23.5-44.5,46.9-66.9,70.5c11.9,11.1,23.6,22,35.4,33.1 c0.6-0.5,1.1-1,1.5-1.5c10.1-10.2,20.2-20.4,30.4-30.5c4.3-4.3,10.8-3.8,14,1c2.4,3.5,2,8-1.1,11.3c-2.8,3-5.7,5.8-8.6,8.7 c-9.6,9.7-19.2,19.4-28.8,29c-4.4,4.4-9.3,4.5-13.9,0.2c-15.6-14.6-31.2-29.2-46.8-43.7c-4.6-4.3-4.8-9.4-0.4-14 c25.9-27.4,51.9-54.7,77.9-82.1c4.3-4.5,9.4-4.6,13.9-0.3c29.9,28.3,59.7,56.6,89.6,84.9c4.2,3.9,4.4,9.3,0.4,13.5 c-28.3,29.9-56.7,59.9-85,89.8c-3.8,4-9.3,4.3-13,0.8c-3.7-3.4-3.7-9.1,0.1-13c16.6-17.6,33.3-35.2,49.9-52.7 c9.4-9.9,18.8-19.9,28.2-29.8C207.1,119,207.4,118.6,207.9,118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.1,224.2c0-6,4.8-10.8,10.7-10.8c5.9,0,10.7,4.8,10.7,10.8c0,6-4.7,10.6-10.8,10.6 C110.7,234.8,106.1,230.2,106.1,224.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,10.8c-0.1-6,4.7-10.8,10.7-10.8c6,0,10.8,4.7,10.8,10.7c0,5.9-4.7,10.6-10.6,10.7 C105,21.4,100.2,16.8,100.1,10.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1224.7,986.3H190.6C85.5,986.3,0.2,901,0.2,795.8V105.6h1276.6c105.2,0,190.4,85.2,190.4,190.4v447.8 C1467.2,877.7,1358.7,986.3,1224.7,986.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3718,3334.4 2696.1,3350.8 2176.9,2831.6 2696.1,2312.5 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2799.3,1603.3c140.5-35.3,385.5-147.5,345.8-373c-34.9-197.8-219.9-181.1-310.4-248.9 c-145.5-109-203.7-260.6-423.1-285.2c-185.9-20.9-379.7,37.8-480.9,185c-142.4,207.1-99.7,572.1,107.8,671.4 C2263,1660,2595.8,1654.3,2799.3,1603.3L2799.3,1603.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1251.8,1069c16.6-287.8,141.8-323.3,161.5-299C1454.5,820.7,1311.5,979.5,1251.8,1069z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1399.7,781.3c-70.1,81.7-120.1,180.5-144.4,285.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1362.7,783.8c4.1,12.1,6.3,24.7,6.6,37.4c13.4-2.9,27-4.4,40.7-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1314.5,833.7c7.9,13.7,13.7,28.5,17.2,43.9c15.9-3.4,32.2-5.1,48.5-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1281.3,906c6.6,10.3,12.2,21.1,16.9,32.4c15.4-6.2,32.1-9.2,48.7-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1312.7,975.5c-10.1-0.7-20.3,0-30.2,2.2c-2.6-8.2-6.2-16-10.8-23.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1251.8,1069c92-146.5,209.5-194.8,214.8-141.8C1474.1,1000.4,1315.4,1048.3,1251.8,1069z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1452,932.3c-72.4,34.6-139.5,80.5-197.9,135.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1426,917c0.3,10.2-0.7,20.5-2.9,30.4c10.1,1,19.8,4.9,27.7,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1377,939.7c1.9,10.8,2.7,21.7,2.2,32.6c13.6,1.2,26.9,5.9,38.2,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1330.5,973.4c3.8,8.4,5.5,17.7,5.1,27c12.6,1,24.9,5,35.7,11.5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1090.4,
    y: 839,
    className: "st4",
    width: 204,
    height: 21.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1288.4,860.4 1288.4,1069 1270.4,1069 1270.4,1057.6 1114.4,1057.6 1114.4,1069 1096.4,1069  1096.4,860.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1096.4,
    y: 860.4,
    className: "st5",
    width: 192,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1115.6,
    y: 879.1,
    className: "st5",
    width: 153,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 874.8,
    className: "st6",
    width: 156.2,
    height: 46.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1115.6,
    y: 937.6,
    className: "st5",
    width: 153,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 933.3,
    className: "st6",
    width: 156.2,
    height: 46.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1115.6,
    y: 996.1,
    className: "st5",
    width: 153,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 991.8,
    className: "st6",
    width: 156.2,
    height: 46.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1140.5,828.6v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1142.2,832.5,1140.5,830.8,1140.5,828.6 L1140.5,828.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1138.9,795.1L1138.9,795.1c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1139.3,796.2,1138.9,795.7,1138.9,795.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1141.9,828.1v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1143.3,831.1,1141.9,829.8,1141.9,828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1158.3,828.6v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1160.1,832.5,1158.3,830.8,1158.3,828.6 L1158.3,828.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1156.7,795.1L1156.7,795.1c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1157.2,796.2,1156.7,795.7,1156.7,795.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1159.7,828.1v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1161.1,831.1,1159.7,829.8,1159.7,828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1177.2,828.6v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1179,832.5,1177.2,830.8,1177.2,828.6 L1177.2,828.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1175.6,795.1L1175.6,795.1c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1176.1,796.2,1175.6,795.7,1175.6,795.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1178.6,828.1v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1180,831.1,1178.6,829.8,1178.6,828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1196.5,828.6v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1198.2,832.5,1196.5,830.8,1196.5,828.6 L1196.5,828.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1194.9,795.1L1194.9,795.1c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1195.3,796.2,1194.9,795.7,1194.9,795.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1197.9,828.1v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1199.3,831.1,1197.9,829.8,1197.9,828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1217.2,828.6v-32.5h8.9v32.5c0,2.2-1.8,3.9-3.9,3.9h-1.1C1218.9,832.5,1217.2,830.8,1217.2,828.6 L1217.2,828.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1215.6,795.1L1215.6,795.1c0-0.6,0.5-1,1-1h10.1c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1-1,1h-10.1 C1216,796.2,1215.6,795.7,1215.6,795.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1218.6,828.1v-21.2h6.1v21.2c0,1.7-1.4,3-3,3l0,0C1220,831.1,1218.6,829.8,1218.6,828.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1131.7,
    y: 798,
    className: "st9",
    width: 109.8,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1125.9,
    y: 831.9,
    className: "st2",
    width: 122.7,
    height: 7.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1130.8,
    y: 794.1,
    className: "st2",
    width: 3.1,
    height: 41.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1239.6,
    y: 794.1,
    className: "st2",
    width: 3.1,
    height: 41.3
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M682.7,941c25.8-32.4,38.5-75,34.5-116.1s-24.6-80.5-57.4-107.8c0.5,30.5-0.8,61-3.8,91.4 c-2.8,28.9-7.2,58.4-0.3,86.6C659.8,911.8,667.9,927.6,682.7,941z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M680.3,978.1c0-102,27.1-135-12.6-242.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M686.6,753.1c-2.8,5.9-5.5,11.8-8.3,17.7c-4.9-2.4-10.3-3.9-15.8-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M659,814.5c10.4,0.4,20.7,3.2,29.9,8.1c6.1-7.5,13.3-14.1,21.4-19.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M657.8,864c10.4-0.9,21.2,1.9,29.9,7.7c8.5-9,18.3-16.8,28.9-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M662.5,904.8c7.8,0.8,15.3,4.6,20.7,10.3c5.7-7.7,12.6-14.5,20.4-20.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M701.3,937.9c0,0-22-48.1,6.2-100.7c15.5-29.1,49.1-64.4,91-94c0,0-19.9,108.6-44.7,154 C734.8,932.2,701.3,937.9,701.3,937.9L701.3,937.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M783.4,764.3c-43.3,69.5-74.1,145.4-98.5,223.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M755.9,781.5c2.6,6,4.7,12.3,6.2,18.7c7.3-1.4,14.8-2.3,22.2-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M721.5,825.1c6.1,8.6,11,18,14.6,27.9c11.5-5.5,23.8-9.3,36.4-11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M701.3,862c7.4,9.5,13.1,20.5,16.5,32c12.9-5.4,26.4-9.5,40.2-12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M695.8,906.4c4.3,4.8,8.3,9.8,12,15c9.5-3.9,19.5-6.7,29.6-8.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.9,947.7c0,0,19-27,5-73.8c-19.3-64.2-99.6-109.7-99.6-109.7s21.5,87.8,38.3,131.5 C620.6,939.9,659.9,947.7,659.9,947.7L659.9,947.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M664.9,971.2c0,0-11-88.3-89-194.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M604.2,795.1c-2.3,5.3-3.8,10.9-4.5,16.7c-5.5-1.5-11.1-2.3-16.8-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M593.9,854.5c10.6-1.6,21.7-0.9,32,2.2c2-9.5,6.5-18.6,12.9-26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M662,872.9c-7.3,8-13,17.4-16.7,27.5c-10.1-4.4-21.7-5.1-32.3-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M635.7,933.5c7-1.3,14.1-1.4,21.1-0.3c2.4-5.6,5.9-10.7,10.2-15"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "733.2,955.1 730.2,972.1 726.9,990.8 725.1,1000.5 721.8,1019.2 713,1069 648.9,1069 639.9,1019.2  636.5,1000.5 634.8,990.8 631.4,972.1 628.3,955.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "730.2,972.1 726.9,990.8 634.8,990.8 631.4,972.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "725.1,1000.5 721.8,1019.2 639.9,1019.2 636.5,1000.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 744.9,
    y: 1042.9,
    className: "st11",
    width: 105.1,
    height: 9.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M762.8,952.5c0,0.2,0,0.5-0.1,0.7l-1.6,13.5l-14.5,120c-0.4,3.2-3.2,5.5-6.4,5.1c-2.9-0.4-5-2.9-5-5.8 c0-0.2,0-0.5,0.1-0.7l14.4-118.5l1.8-14.9c0.4-3.2,3.2-5.5,6.4-5.1C760.7,947,762.8,949.5,762.8,952.5L762.8,952.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M762.8,952.5c0,0.2,0,0.5-0.1,0.7l-1.6,13.5h-11.5l1.8-14.9c0.4-3.2,3.2-5.5,6.4-5.1 C760.7,947,762.8,949.5,762.8,952.5L762.8,952.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M804.6,951.4v134.5c0,3.2-2.5,5.9-5.7,5.9c-1.6,0-3-0.7-4-1.7c-1-1.1-1.7-2.5-1.7-4.2V951.4 c0-3.2,2.6-5.9,5.7-5.9c1.6,0,3,0.7,4,1.7S804.6,949.8,804.6,951.4L804.6,951.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M802.9,947.3c1,1.1,1.7,2.5,1.7,4.2v15.2h-11.4v-15.2c0-3.2,2.6-5.9,5.7-5.9 C800.4,945.6,801.9,946.2,802.9,947.3L802.9,947.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M862,1085.9c0,2.9-2.1,5.4-5,5.8c-3.1,0.4-6-1.9-6.4-5.1l-14.5-120l-1.6-13.5c0-0.2-0.1-0.5-0.1-0.7 c0-2.9,2.1-5.4,5-5.8c3.1-0.4,6,1.9,6.4,5.1l1.8,14.9l14.3,118.5C862,1085.4,862,1085.7,862,1085.9L862,1085.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M847.6,966.7h-11.5l-1.6-13.5c0-0.2-0.1-0.5-0.1-0.7c0-2.9,2.1-5.4,5-5.8c3.1-0.4,6,1.9,6.4,5.1 L847.6,966.7L847.6,966.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M872.4,936.3v3.8c0,6.7-5.4,12.1-12.1,12.1H752.4c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h107.9C867,924.2,872.4,929.6,872.4,936.3L872.4,936.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.4,936.3v3.8c0,6.7-5.4,12.1-12.1,12.1h-98c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h98C867,924.2,872.4,929.6,872.4,936.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M759.7,696c-1.4,2.8-2.7,5.5-3.9,8.2c-0.8,4.8-0.3,9.6,0,14.5s0.5,9.8-0.8,14.4s-4.5,9.1-9.2,10.8 c-3,1.2-6.6,1.2-9,3.4c-2.6,2.5-2.5,6.7-1.5,10.1c0.8,2.9,2.1,5.8,4.4,7.8c2.3,2,6,3.3,8.5,1.9c2.5-1.5,5.8-0.4,7.6,1.8 s2.6,5,4.4,7.3c2.5,3.2,6.7,4.8,10.8,4.9s8.5-0.5,11.3-2.2c5.9-3.7,13.2-6.2,19.3-2.7c3.2,1.8,5.7,4.7,9.1,6 c2.9,1.1,6.3,0.9,9.1-0.6s3.8-4.6,5.5-7c3.2-4.4,10.8-0.8,16.2-2.3c5.7-1.6,9.5-7.8,8.2-13.4s-7.5-7.6-13-8.4 c-3.8-0.6-5.3-5.4-6.2-9c-0.9-3.6-0.7-7.4-0.6-11.1c0.3-7.5,3.8-25.2,1.6-27.5c-1.1-1.2-5.4-4.4-7-5.1 c-7.2-3.3-14.3-6.5-21.5-9.8c-6.5-3-13.3-6-20.6-5.8C775.3,682.7,764.9,685.5,759.7,696L759.7,696z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M784.5,764c0,0-31.8,5-35.1,16.3c-3.4,11.3,15.9,90,15.9,90l71.4-4.4c0,0,5.2-90.8-6.2-96.5 C819.2,763.7,784.5,764,784.5,764L784.5,764z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M812.3,767.1c0,0-4.6,15.8-13,19.2c-8.4,3.5-26.8-17.6-26.8-17.6c3.7-2.3,5.1-8,5.6-13.2 c0.5-5.2-0.1-10-0.1-10l25.5,4.9c-0.7,7.9,1.7,12.1,4.1,14.2C809.9,766.8,812.3,767.1,812.3,767.1L812.3,767.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M807.5,764.7c-12.1,1.6-23.1-4.5-29.6-9.2c0.5-5.2-0.1-10-0.1-10l25.5,4.9 C802.8,758.4,805.1,762.6,807.5,764.7L807.5,764.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M881.4,1063.2c-2.8,4.6-50.5-24.9-50.5-30c0-3.3,6.2-8.1,10.6-11c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1 l5,2.7c7.3,12.6,14.3,25.8,17.8,34.9C881.6,1057.5,882.4,1061.5,881.4,1063.2L881.4,1063.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M879.5,1052.1c-13.7,0.6-31.8-21.6-38.1-29.9c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1l5,2.7 C869.1,1029.8,876,1042.9,879.5,1052.1L879.5,1052.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M832.2,872.6c0,0,87,11,90,33.3c3,22.3-54.6,120.5-54.6,120.5l-20.7-5.4l27-87.8l-69.3-29.4l13.8-31.2 H832.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M860.3,1065.8c-2.8,4.6-50.5-24.9-50.5-30c0-3.3,6.2-8.1,10.6-11c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1 l5,2.7c7.3,12.6,14.3,25.8,17.8,34.9C860.4,1060,861.3,1064.1,860.3,1065.8L860.3,1065.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M858.4,1054.6c-13.7,0.6-31.8-21.6-38.1-29.9c2.3-1.6,4.1-2.6,4.1-2.6l11.2-5.1l5,2.7 C847.9,1032.3,854.9,1045.5,858.4,1054.6L858.4,1054.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M758.9,865.2c0,0-30.1,59.6,22.9,66c38.5,4.7,64.1,3.7,64.9,5.9c1.3,3.4-25.1,86.7-25.1,86.7l26,8.2 c0,0,53.8-115.5,50.8-125.5c-2.4-8.3-76.6-20.9-76.6-20.9c6.2-3,10.8-13.8,10.2-27.7L758.9,865.2L758.9,865.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M767.2,860c0,0-17.3,38-3.5,53.5c16.3,18.2,87.6,12.3,92.6,18.8c4,5.2-27.5,89.3-27.5,89.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 823.7,
    y1: 1020.3,
    x2: 848.8,
    y2: 1027.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M824.5,718.2c6.1-0.7,11.5,2.4,12,6.8s-4,8.7-10.2,9.4c-6.1,0.7-11.5-2.4-12-6.8 S818.3,718.9,824.5,718.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M763.8,717.8c0-21.2,13.4-38.3,31.5-38.3s32.7,17.2,32.7,38.3s-9.2,39.4-26.2,40 C784.6,758.5,763.8,739,763.8,717.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M765.5,722.7c9.1-4.2,16.5-11.7,19.9-20.9c4.7,5.3,11.5,8.3,18.5,9.6s14.1,1.1,20.8,0.9 c2.2,1.8,3.7,4.4,4.2,7.2c0.8-6.3,0.1-12.7-2-18.7c-18-5.5-35.8-11.3-53.6-17.5C770.7,695.9,768,708.6,765.5,722.7 L765.5,722.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M782.5,692.1c3.9,7.3,11.3,12.1,19.2,14.7c7.9,2.5,16.2,2.9,24.6,3.2c1.3,4.6,1.6,10,1.6,14.7 c2.9-6.7,4.4-12.4,4.6-17.9c0.1-1.6,0.1-3.2,0-4.9c-0.4-11.6-5.2-18.3-11.7-23.2c-6.5-5-14.4-7.1-22.6-7.1s-13.2,1.8-16.2,5 c-1.1,1.1-1.9,2.4-2.5,3.8C778.1,683.4,779.6,686.7,782.5,692.1L782.5,692.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M755.6,725.3c-0.3-10.3-0.9-28,3.2-36.5c2.7-5.5,7.9-10.1,14-11c6.1-0.8,12.9,3,14.3,9 c-2.7,13.9-9.7,26.7-19.6,36.7C764.1,725.1,759.1,726.2,755.6,725.3L755.6,725.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M782,676.4c11.8-3.2,25.1-0.4,34.8,7c7.6,5.8,13,14.1,15.7,23.2c0.1-1.6,0.1-3.2,0-4.9 c-0.4-11.6-5.2-18.3-11.7-23.2c-6.5-5-14.4-7.1-22.6-7.1S785,673.3,782,676.4L782,676.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M751.8,725.6c1.1-4.4,6.9-6.7,12.8-5.1c6,1.5,9.9,6.3,8.8,10.7s-6.9,6.7-12.8,5.1 C754.6,734.7,750.7,730,751.8,725.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 796.5,
    cy: 728.4,
    rx: 1.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 820.1,
    cy: 728.4,
    rx: 1.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M815.1,715.7c2.9-1,7-0.8,9.9,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M797.9,715.4c-3.2-1.4-9-1.1-11.8,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M808.6,726.7c0.8,2.9,0.2,6.5-0.7,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M806.5,743.8c-3.8,0.7-10.6-1.4-12.4-4.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M820.1,776.7l12.7-7.7c0,0,10.7,0.9,18,14.3c7.2,13.3,20.9,56.3,25.2,58.2s56.6,2.6,56.6,2.6l0.7,15.3 c0,0-64.1,10.2-71.8,6c-7.7-4.2-32.4-53.8-32.4-53.8L820.1,776.7L820.1,776.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M819.3,775l2.5-8.6c0,0,14.1,0.6,21.3,6.2c7.2,5.6,13.1,21,13.1,21l-18.3,29.5L819.3,775L819.3,775z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M841,834.2c0,0,19.6-17,22.7-21.2c1.5-2.1,12.1,22.6,10.3,25.6c-2.9,4.8-20.8,16.4-21.8,15.7 S841,834.2,841,834.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M835.9,818.7c5.9-9.4,11.8-18.8,17.8-28.2c0.3-0.5,0.7-1.1,1.2-1.4c1.5-1,3.6,0.2,4.2,1.9 c0.6,1.7,0.2,3.5-0.3,5.2c1.9-0.3,3.6,1.6,3.8,3.5c0.2,1.9-0.6,3.8-1.5,5.5c-5.5,10.4-14.7,18.7-25.5,23.2 C835.1,825.1,834.1,821.6,835.9,818.7L835.9,818.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M924.5,846.4c7.3-5.2,21.5-15.4,22.6-15.8c1.3-0.6,9.9-0.6,14.6,0.8c4.7,1.4,9.1,4.7,10.8,9.3 c0.5,1.3,0.6,3-0.5,3.8c-0.7,0.5-1.8,0.3-2.5-0.1s-1.3-1.2-2-1.8c-3.1-3.4-6-4.8-11.1-5c6.1,0.9,10,4.7,11.8,10.6 c0.4,1.2,0.5,2.7-0.5,3.5c-0.8,0.6-1.9,0.4-2.7-0.1s-1.4-1.4-2-2.1c-2.2-2.8-5.2-5.1-8.6-6.4c4.7,2,8.2,6.5,8.9,11.6 c0.1,0.7,0.2,1.5-0.1,2.2s-1,1.2-1.7,1.1c-0.6-0.1-1-0.6-1.4-1c-2.5-2.9-4.5-5.9-7.9-8c3.1,4.1,5.7,10.8,5,12.5 c-0.2,0.5-1.5,1.4-3,0c-1.7-1.7-2.8-4.5-5.4-7.7c-4.4,5-11.6,7.2-18.1,5.8C928.5,855,926.5,850.6,924.5,846.4L924.5,846.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M937.9,839.9c5.2-1.9,10.5-3.5,15.9-4.8c0.7-0.2,1.5-0.3,2.2-0.3s1.5,0.5,1.8,1.1 c0.3,0.7,0.1,1.5-0.3,2.1s-1.1,1.1-1.7,1.5c-2.3,1.4-4.7,2.6-7.2,3.8c-0.5,3.8-3.3,7.2-7,8.5"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M808,765c3,2.7,5,17.6,6.6,27.1c2.3,14.2,14.3,76.1,15,80.5c1.3,7.7,25.8,7.2,26.7,3.2 c0.2-0.7-7.2-4.2-8.3-9.1c-1-4.4-9.2-90.6-13.1-95.1C829.8,765.6,807,764.1,808,765L808,765z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M774.4,765c2.5,0.9,10.6,18,14.4,33.5c8,32.6,3.2,80.9,0,87.3c-3.2,6.4-34.5,9.2-39.8,7.5 c-3.1-1-6.4-98.5-4.3-110.7C746.1,774.5,773.6,764.7,774.4,765z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M821.2,873.9c6.6-2.4,25.7-7.4,28.3-7.2c2.7,0.3,5.4,1.2,7.1,3.5c1.1,1.4,1.6,3.2,2.1,5 c0.8,2.8,1.6,5.7,2.4,8.6c0.3,1,0.6,2,0.4,3.1s-0.9,2-1.8,2.1c-1.4,0.1-2.2-1.5-2.7-2.9c-1.3-3.5-2.6-7.1-3.8-10.6 c0.8,4.4,1.7,8.8,2.5,13.2c0.2,1,0.4,2.1,0.2,3.1c-0.2,1-1,2-2,2c-1.5,0-2.2-1.9-2.5-3.4c-0.7-3.4-1.5-6.9-2.6-10.3 c1.5,4.8,1.7,10.1,0.6,15c-0.2,0.8-0.4,1.6-0.9,2.1c-0.5,0.5-1.4,0.7-2,0.2c-0.4-0.4-0.5-1-0.6-1.6c-0.4-4.4-0.9-8.9-1.3-13.3 c0.4,4.7,0.8,9.5-0.5,13.9c-0.2,0.8-0.5,1.6-1.1,2.1s-1.5,0.7-2.1,0.2c-0.6-0.5-0.7-1.4-0.7-2.2c-0.1-2.8-0.2-5.6-0.2-8.8 c-2.5,2.9-5.8,4.8-9.4,5.3s-7.3-0.3-10.9-1.4C820,886.5,820.3,881.3,821.2,873.9L821.2,873.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M772.4,794.1c-2-9.2-10.3-24.2-17-21.1c-3.9,1.8-15,5.5-15,29.9c0,33,4.3,76.3,15,83.6 c5.4,3.7,64.7,7.3,64.7,7.3l4.3-21.2c0,0-43.7-8.1-45.7-14.1C775.9,850.1,777.7,818.7,772.4,794.1L772.4,794.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M767.2,789.1c7.3,24.8,8.9,67,10,69.5c1,2.3,6.6,3.3,10.9,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M775.6,890.3c-8.1-0.8-18.2-2.4-20.5-4.1c-2.7-2-5.9-11.7-8.2-18.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M774.4,830.1c2.9-3.7,4.1-9.7,4.4-17.2"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 990.9,
    y: 1040.4,
    className: "st11",
    width: 105.1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1008.9,952.3c0,0.2,0,0.5-0.1,0.7l-1.6,13.1L992.7,1083c-0.4,3.1-3.2,5.4-6.4,5c-2.9-0.4-5-2.8-5-5.7 c0-0.2,0-0.5,0.1-0.7l14.3-115.5l1.8-14.5c0.4-3.1,3.2-5.4,6.4-5C1006.8,947,1008.9,949.5,1008.9,952.3L1008.9,952.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1008.9,952.3c0,0.2,0,0.5-0.1,0.7l-1.6,13.1h-11.5l1.8-14.5c0.4-3.1,3.2-5.4,6.4-5 C1006.8,947,1008.9,949.5,1008.9,952.3L1008.9,952.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1050.6,951.3v131c0,3.2-2.5,5.7-5.7,5.7c-1.6,0-3-0.6-4-1.7c-1-1-1.7-2.4-1.7-4v-131 c0-3.2,2.6-5.7,5.7-5.7c1.6,0,3,0.6,4,1.7C1050,948.3,1050.6,949.7,1050.6,951.3L1050.6,951.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1049,947.3c1,1,1.7,2.5,1.7,4v14.8h-11.4v-14.8c0-3.2,2.6-5.7,5.7-5.7 C1046.5,945.6,1047.9,946.2,1049,947.3L1049,947.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1108.1,1082.3c0,2.8-2.1,5.3-5,5.7c-3.1,0.4-6-1.8-6.4-5l-14.5-116.9l-1.6-13.1 c0-0.2-0.1-0.5-0.1-0.7c0-2.8,2.1-5.3,5-5.7c3.1-0.4,6,1.8,6.4,5l1.8,14.5l14.3,115.5 C1108.1,1081.8,1108.1,1082,1108.1,1082.3L1108.1,1082.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1093.7,966.1h-11.5l-1.6-13.1c0-0.2-0.1-0.5-0.1-0.7c0-2.8,2.1-5.3,5-5.7c3.1-0.4,6,1.8,6.4,5 L1093.7,966.1L1093.7,966.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1118.5,936.3v3.8c0,6.7-5.4,12.1-12.1,12.1H998.5c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h107.9C1113.1,924.2,1118.5,929.6,1118.5,936.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1118.5,936.3v3.8c0,6.7-5.4,12.1-12.1,12.1h-97.9c-6.7,0-12.1-5.4-12.1-12.1v-3.8 c0-6.7,5.4-12.1,12.1-12.1h97.9C1113.1,924.2,1118.5,929.6,1118.5,936.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M977.1,764c2.2-3.5,0.1-8.2,0.7-12.3c0.2-1.1,0.7-2.3,1.6-3s2.3-0.8,3.2,0c1,1,0.7,2.6,0.7,4 c0,2.5,1.2,4.9,1.7,7.4c1.3,6-1.9,11-5,16.2c-3.8,2.7-9,4.5-12.2,4.8c-2,0.2-12.4-5.5-16.5-17.8c-2-6.2-1.8-8.7-1.1-9.6 s2-1.2,2.9-0.6c0.5,0.4,0.8,1,1,1.7c1.3,3.7,2.6,7.4,3.8,11.2c-5-4.7-7.8-11.6-7.4-18.5c0.1-1.3,0.5-2.9,1.7-3.3 c0.8-0.3,1.7,0.1,2.3,0.7s1,1.4,1.3,2.1c1.8,3.9,3.6,7.8,6.1,12.4c-4.6-4.3-6.5-11.2-4.9-17.3c0.3-1,0.9-2.2,2-2.2 c1.1,0,1.7,1.2,2.1,2.2c1.8,4.9,3.7,9.8,5.5,14.7c-2.6-4.1-3.7-9.1-3.1-13.9c0.2-1.7,1.1-3.8,2.9-3.9c1,0,1.9,0.6,2.5,1.5 s0.7,1.8,1,2.8C971.3,749,973.8,754.3,977.1,764L977.1,764z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M951.4,753.2c1.6-0.4,2.8,0.1,3.4,2.5c0.9,3.3,3.2,11,5.7,12.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "980.6,773.2 986.5,787.1 970.7,796.7 963.7,778.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M979.9,756.8c-1.1-6.4-6-11-11.4-11.6l-0.1-0.4c0,0-2.9,0.5-3.8,0.7c-6.2,1.4-10.1,8.4-8.8,15.7 c1.3,7.2,7.3,12.5,13.7,11.6c1-0.1,3.8-0.6,3.8-0.6l-0.1-0.4C978.1,769.2,981,763.2,979.9,756.8L979.9,756.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M968.1,744.8c6.7-1.2,13.2,4,14.5,11.5c1.3,7.6-3,14.7-9.6,15.8c-6.7,1.2-13.2-4-14.5-11.5 C957.1,753,961.5,745.9,968.1,744.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M979.9,756.8c-1-5.8-6-9.8-11.2-8.9c-0.1,0-0.2,0-0.3,0.1c-5,1-8.2,6.4-7.2,12.1 c1,5.7,5.9,9.7,10.9,8.9c0.1,0,0.2,0,0.3,0C977.6,768.1,980.9,762.6,979.9,756.8L979.9,756.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1029,769.5l-9.7-7.4c0,0-6.3,3.6-9.7,11.1c-3.4,7.5-7.9,32.6-7.9,32.6l-18.2-30.2L960.4,792 c0,0,25.7,65,41.1,65.8s26.3-13.5,26.3-13.5L1029,769.5L1029,769.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "952.4,1050.3 955.3,1069 967.5,1073.9 981.5,1067.2 978.9,1048.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M989.4,1091.8l-63.2-0.9c0,0-0.4-1.3-0.6-3.2c-0.3-3,0.2-7.4,3.9-10.3c5.3-4.1,13.7-4.7,19.2-6.8 c3.3-1.3,5.3-4.5,5.3-4.5l9,0.5c0,0,0.7,5,4.1,4.7s14.4-5.7,14.4-5.7c5.7,9.8,7.4,17.6,7.8,22.1 C989.5,1090.3,989.4,1091.8,989.4,1091.8L989.4,1091.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M989.4,1091.8l-63.2-0.9c0,0-0.4-1.3-0.6-3.2h63.6C989.5,1090.3,989.3,1091.8,989.4,1091.8 L989.4,1091.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1027.9,1050.3 1030.8,1069 1043,1073.9 1057,1067.2 1054.5,1048.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1064.9,1091.8l-63.2-0.9c0,0-0.4-1.3-0.6-3.2c-0.3-3,0.2-7.4,3.9-10.3c5.3-4.1,13.7-4.7,19.2-6.8 c3.3-1.3,5.3-4.5,5.3-4.5l9,0.5c0,0,0.7,5,4.1,4.7c3.3-0.3,14.4-5.7,14.4-5.7c5.7,9.8,7.4,17.6,7.8,22.1 C1065,1090.3,1064.9,1091.8,1064.9,1091.8L1064.9,1091.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1064.9,1091.8l-63.2-0.9c0,0-0.4-1.3-0.6-3.2h63.6C1065,1090.3,1064.9,1091.8,1064.9,1091.8 L1064.9,1091.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1024.2,866.3l-10.3,16.8c0,0-59.2,9-68.8,23.5c-8.8,13.4,3.1,149,3.1,149h40.7c0,0-3.1-100.2,0-109.5 s96.4-8.8,101.7-21.3c5.3-12.6,7.1-56.7,7.1-56.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M1099.3,885.7c0,0,2.3,36.3-9.6,45c-10.4,7.5-36.7,9.5-36.7,9.5l5.1,112.9l-38.9,2.5 c0,0-19.3-131.8-18.4-144.5c0.9-12.6,38.3-21.8,35.8-23.6c0,0-28.8-9.8-18.2-20.5c0.2-0.2,0.5-0.5,0.8-0.7 c2.5-2.2,32.9,0.1,32.9,0.1l28-2.6l11.1,12.6L1099.3,885.7L1099.3,885.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1097.9,897.1c-0.2,1.8-0.5,3.7-0.8,5.6c-4.8-6.1-12.5-15-19.4-18.8c-14.2-7.8-59.5-13.1-59.5-13.1 l0.2-3.9c0.2-0.2,0.5-0.5,0.8-0.7c2.5-2.2,32.9,0.1,32.9,0.1l28-2.6l11.1,12.6L1097.9,897.1L1097.9,897.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1079.1,751.3c0,0-16.7,21.5-27.1,20.4c-10.4-1.1-18.5-12.6-18.5-12.6s4.2-1.5,6-8.3 c1.1-3.9,1.3-9.6-0.5-17.8l30.9-4.6c0,0-0.2,5.2,1.2,10.7C1072.2,743.9,1074.5,748.9,1079.1,751.3L1079.1,751.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1039.5,750.8c1.1-3.9,1.3-9.6-0.5-17.8l30.9-4.6c0,0-0.2,5.2,1.2,10.7 C1062.7,746.1,1051.3,750.4,1039.5,750.8L1039.5,750.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1010.7,714.8c0.5-4.2,5.5-7,11.2-6.4c5.7,0.7,10,4.6,9.5,8.7c-0.5,4.2-5.5,7-11.2,6.4 S1010.2,718.9,1010.7,714.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1022.4,715.9v-0.1c0-1.4-1.1-2.5-2.5-2.5h-1.4c-1.4,0-2.5,1.1-2.5,2.5v0.1c0,1.4,1.1,2.5,2.5,2.5 h1.4C1021.3,718.3,1022.4,717.2,1022.4,715.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1016.1,
    y: 715.8,
    className: "st42",
    width: 2.1,
    height: 5.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1080.4,704c0-19.7-13.6-35.7-30.5-35.7s-30.5,10.5-30.5,35.7c0,19.7,7.7,36.8,25.8,38 C1062,743.1,1080.4,723.7,1080.4,704L1080.4,704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1076.8,713.3c-5.6-5.4-9.7-12.2-11.7-19.8c-2.8,0.9-6.1,0.3-8.2-1.2c-6.2,2.5-13.5,2-19.2-1.1 c-4.4,2-9.7,2-14.2-0.4c-2.1,2.9-3.7,6.2-4.7,9.7c0.4-6.8,0.9-13.6,1.3-20.4c16.1-2.3,32.2-3.8,48.5-4.7 c0.9-0.1,1.9-0.1,2.7,0.3c1.2,0.6,1.7,2,2.1,3.4C1076.8,690.2,1078.6,702,1076.8,713.3L1076.8,713.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1084.5,677.8c-0.7,10.1-1.3,23.2-2,33.2c-0.9,3.4-3.9,3.3-7.9,4.6c-3.7-8.3-6-17.2-7.4-27 c-3.9,1-8.1,0.7-12.1-0.8c-6,2.3-12.7,2.4-18.8,0c-4.6,1.5-9.7,1.8-14,0.3c-1.6,5-2.4,12.5-2.9,17.8 c-0.6-4.9-2.5-19.9-2.9-30.2c-0.2-4.4-0.2-8,0.4-9.5c1.9-5.6,8.1-3.8,9.8-1.9c1.1-2.6,3.5-4.6,6.3-5.2s5.8,0.1,8.3,2 c1.7-3.2,5.3-5.4,8.9-5.5c3.7-0.1,7.3,2,8.6,5.5c1.7-0.9,3.5-1.8,5.4-2.2c1.9-0.4,4-0.2,5.6,0.9c0.8,0.5,1.5,1.2,2,2.1 c0.6,0.9,0.9,2,1.1,3.2c1.5-2.2,4.8-2.5,7.1-1.3c2.3,1.2,3.8,3.7,4.4,6.3C1084.9,672.5,1084.7,675.2,1084.5,677.8 L1084.5,677.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1071.7,661.7c-2-0.9-4.3-1.1-6.5-0.6c-2.7,0.6-5.2,2.3-6.5,5c-1.3-3.4-4.9-5.8-8.5-5.6 c-3.6,0.2-7,2.9-8.7,7.2c-1.9-2.3-5.1-3.6-8.1-3.2s-5.8,2.3-7.1,5.3c-1-1.2-2.9-1.5-4.4-0.9c-1.5,0.6-2.7,1.8-3.6,3.1 c-0.8,1.1-1.3,2.3-1.8,3.6c-0.2-4.4-0.2-8,0.4-9.5c1.9-5.6,8.1-3.8,9.8-1.9c1.1-2.6,3.5-4.6,6.3-5.2s5.8,0.1,8.3,2 c1.7-3.2,5.3-5.4,8.9-5.5c3.7-0.1,7.3,2,8.6,5.5c1.7-0.9,3.5-1.8,5.4-2.2c1.9-0.4,4-0.2,5.6,0.9 C1070.5,660.1,1071.2,660.8,1071.7,661.7L1071.7,661.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M1031.8,702.4c-2.6-0.6-5.5-0.1-7.8,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M1051.9,703c2.8-1.2,6.3-0.9,8.9,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1039.7,713.9c0.1,2.8,0.4,5.6,0.8,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1043.7,730.1c3.4,0.1,6.9-1.2,9.4-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M1053,713.2c0.9-0.2,1.7,0.6,1.9,1.8c0.2,1.1-0.3,2.2-1.2,2.3s-1.7-0.6-1.9-1.8 C1051.6,714.4,1052.1,713.4,1053,713.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M1029.1,713.6c0.9-0.2,1.7,0.6,1.9,1.8c0.2,1.1-0.3,2.2-1.2,2.3s-1.7-0.6-1.9-1.8 C1027.7,714.7,1028.3,713.7,1029.1,713.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1077.7,708.4c5.7-0.8,10.8,2,11.4,6.1s-3.6,8.2-9.3,9c-5.7,0.8-10.8-2-11.4-6.1 C1067.9,713.2,1072,709.2,1077.7,708.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1077.4,715.9v-0.1c0-1.4,1.1-2.5,2.5-2.5h1.4c1.4,0,2.5,1.1,2.5,2.5v0.1c0,1.4-1.1,2.5-2.5,2.5h-1.4 C1078.5,718.3,1077.4,717.2,1077.4,715.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.7,
    y: 715.8,
    className: "st42",
    width: 2.1,
    height: 5.7
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M1075.3,746.5c0,0-16.9,10.2-19.8,13.9c-2.9,3.7-3.8,8.7-3.8,8.7s-4-8.5-5-9.3s-8-7.4-8-7.4l-8.3,6.3 l-11.1,5.8l0.5,107l75.4,5.1l1.9-116.1L1075.3,746.5L1075.3,746.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1051.6,769.7c-3.6,30,2.6,82.5-7.4,102.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1053,764.7c0,0,1.3-4.7,4.2-7.1c2.9-2.3,18-11.2,18.4-11.3s7.8,5.1,7.8,5.1l-11.2,15.9 c0,0-11.5-8.1-14.2-7.4C1055.5,760.5,1053,764.7,1053,764.7L1053,764.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1049.5,764.7c0,0-0.9-3.3-2.4-5.2c-1.8-2.2-7.6-8.5-8.2-8.5c-0.6,0-6.5,3.6-7.6,5.8 c-1.1,2.2-0.5,12.3-0.5,12.3s10-9.5,13.9-8.5C1047.4,761.4,1049.5,764.7,1049.5,764.7L1049.5,764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1081.8,749.5c0,0-13.1,12.3-15.1,24.8c-2,12.5-1.2,78.2,10.9,100c10.5,19,11.5,79.3,11.5,107.4 l36.8-12.7c0,0-0.2-50.3-12-96.9c-9.2-36.1-0.4-102-5.6-108.5C1104.6,759.1,1081.8,749.5,1081.8,749.5L1081.8,749.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1066.3,819.6c0,0-3-34.7-0.1-45.9c2.9-11.2,11.4-25.4,13.7-25.9c3.8-0.8,12.3,5.8,12.3,5.8 s-6.9,11.9-8.9,30c-0.2,1.6-13.7,6.6-13.7,6.6s10.5,7.7,10.4,8.5C1079.9,799.4,1066.3,819.6,1066.3,819.6L1066.3,819.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    cx: 1042.2,
    cy: 878.7,
    rx: 14.3,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1061.8,867.1l-14.5-1.9c-1.3-0.2-2.7-0.3-3.9,0.2c-1.6,0.8-2.4,2.7-2.5,4.6c2.4,0.2,4.8,0.4,7.3,0.8 c-3,4.1-6.6,7.7-10.7,10.6c-0.9,0.7-1.9,1.3-2.5,2.2c-0.7,0.9-1.1,2.1-0.7,3.2c0.4,1.1,1.4,1.8,2.5,2c1.1,0.2,2.2,0,3.5,0.1 c-0.4,1.6,0.4,3.4,1.9,4.2c1.5,0.8,3.4,0.5,4.8-0.6c0.7,1.4,2.2,2.4,3.8,2.6c1.6,0.2,3.2-0.3,4.6-0.7 c1.1,1.3,2.9,2.1,4.6,2.1c1.8,0,3.5-0.9,4.9-2.1c4.2-3.7,7.6-8.5,9.7-13.7C1069.9,876.5,1065.6,872,1061.8,867.1 L1061.8,867.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1085.3,776.9c-0.4-6.9,3.1-19.9,8.1-21.2c7.7-2.1,20.9,9.5,24.3,18.8c3.5,9.2,13.9,65.9,11,73.6 c-4,10.5-57,38.8-57,38.8l-16.4-24c0,0,36.7-19.9,38.9-26.2C1095.5,832.7,1086.1,793.1,1085.3,776.9L1085.3,776.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1103,765c0,0-5.9,7.8-5.9,21.7s3.4,47,2.6,48.2c-0.8,1.2-26.7,18-26.7,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1097.5,807.8c-3.9-4.6-6.6-10-7.8-15.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1083.5,881.2c8.4-4.6,20.6-11.7,27.9-17.6"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1036.6,751.9c0,0-2.2,8.6-2.2,23.4c0,25-3.2,94.4-16.4,104.6c-10.3,8.1-23.3,7.5-29.2,7.5 c0,0,12.2-6.5,16.8-14c5.1-8.4,5.9-35,6.6-49c0.7-14.7,2-55.3,3.7-58.8C1019.6,758.1,1036.6,751.9,1036.6,751.9L1036.6,751.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1032.3,821.7c0,0,3-23.5,3-39.8c0-18.3,3-30.9,3-30.9s-10.4,3.3-11.5,5s-6.5,11.3-9.3,29.7 c-0.5,3,11.8,5.5,11.8,5.5s-9.5,7.3-9.5,9.2C1019.9,803.9,1032.3,821.7,1032.3,821.7L1032.3,821.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1015.4,773c0,39.8-3.6,71.7-5.3,82.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1009.7,787.3c1,5.7,3.5,11.3,5,13.1"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M1017,721.4c0,0,2,45.9,29.5,47.7c23.2,1.5,36.1-27.1,36.1-47.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1048.3,769.7c0,0-16.9,61.9-63.9,73.1c-57.5,13.7-113.8-1.7-113.8-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M972.4,771.4c0,0,6.5,37.5-22.6,57c-25.8,17.2-79.2,11.9-79.2,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1028.9,878.5c0,0-105.4,0.2-159.1-37.4"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M1249.5,614.3c-0.6-11.2,7.5-22.4,18.4-25.1s23.4,3.2,28.2,13.4c4.1,8.7,2.7,19,0.7,28.4 c-1.9,9.4-4.4,19.2-2.2,28.6c1.9,7.9,7,14.8,8,22.9c1.4,11.1-6.4,22.6-17.2,25.4c-6.1,1.6-14-0.4-15.9-6.4 c-1.8-5.6,2.3-11.5,1.5-17.3c-0.7-4.8-4.7-8.5-7.9-12.1C1251.1,658.6,1250.9,639.1,1249.5,614.3L1249.5,614.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1144.7,756.4c-5.5-6.2-9.5-17.5-9.5-21.2c0-4.5-0.7-9,0.9-13.2c0.8-2.2,2-4.1,3.3-6 c1.4-2.2,2.8-4.4,4.2-6.6c0.6-0.9,1.3-1.9,2.3-2.2c1.8-0.5,3.4,1.5,3.3,3.3c-0.1,1.8-1.3,3.3-3.4,5c0.8-3.3,2.5-6.4,4.8-8.9 c0.6-0.7,1.4-1.3,2.3-1.1c1.4,0.3,1.4,2.4,1,3.8c-1,3.6-1.9,7.2-2.7,10.2c3.1,5.8,2.8,12.7,2.8,19.3c0.1,6.6,0.7,13.7,5,18.6 C1155,759.1,1150.1,751.9,1144.7,756.4L1144.7,756.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1144.1,755.6c0,0,14.5,49.5,25.4,50.5c13.2,1.2,24-11,24-11l8.7-44.3l-19.6-11.7l-10.8,35.5l-15.4-17.5 L1144.1,755.6L1144.1,755.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1209.3,758.2c-10.8-4.1-21.6-8.1-32.4-12.2c2.9-14.1,7-31,10.6-36.3c6.7-10.1,17.5-10.6,17.5-10.6 l4.9,14.6l-0.6,44.3C1209.3,757.9,1209.3,758,1209.3,758.2L1209.3,758.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "1199.4,786.9 1167.8,705.4 1129.2,715.4 1164.9,806.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1194.1,782.4 1165.7,709.8 1134.2,718.4 1165.2,797.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "1155.6,707.9 1157.5,713.1 1145.2,716.6 1143,711.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1180.7,1081.5c0.1,5.3,56.2,3.5,58.8-0.9c1.6-2.9-1.4-10.1-3.7-14.8c-1.2-2.5-2.2-4.3-2.2-4.3l-7.1-10 l-5.7-0.2c-12.6,7.3-25.2,15.2-32.8,21.4C1183.4,1076.4,1180.7,1079.5,1180.7,1081.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1187.9,1072.8c11.6,7.3,38.3-2.9,47.9-7c-1.2-2.5-2.2-4.3-2.2-4.3l-7.1-10l-5.7-0.2 C1208.1,1058.6,1195.5,1066.5,1187.9,1072.8L1187.9,1072.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "1205.1,1029.3 1207.1,1051.2 1207.8,1059 1208.3,1064.4 1231,1062.1 1231.2,1058.2  1231.2,1058.2 1231.4,1054.2 1232.6,1028.4 1232.8,1025.8 1218.9,1027.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "1205.1,1029.3 1207.1,1051.2 1218.5,1052.6 1218.5,1052.6 1228.1,1053.8 1231.4,1054.2  1232.6,1028.4 1218.9,1027.6  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1189.1,810.5c0,0-9.8,27-7.8,65.4c1.9,38.4,18.1,172.2,18.1,172.2l40.3-1.9l-6.9-172.8l-9.7-53.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1281.6,1080.9c3.6,4,45.1-33.8,44.2-38.8c-0.6-3.2-7.6-6.8-12.4-8.9c-2.6-1.1-4.5-1.8-4.5-1.8l-11.9-3 l-4.4,3.6c-4.9,13.7-9.3,27.9-11.1,37.6C1280.4,1075.3,1280.3,1079.5,1281.6,1080.9L1281.6,1080.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1281.4,1069.6c13.6-2,27.3-27.1,31.9-36.4c-2.6-1.1-4.5-1.8-4.5-1.8l-11.9-3l-4.4,3.6 C1287.6,1045.8,1283.2,1060,1281.4,1069.6L1281.4,1069.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "1266.4,1025.4 1275.8,1034.6 1287.7,1046.3 1291.6,1050.1 1307.3,1033.5 1304.9,1030.5  1298.1,1021.7 1285.1,1004.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "1266.4,1025.4 1275.8,1034.6 1298.1,1021.7 1285.1,1004.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M1183.7,835.9c3.9,10.9,33.5,30.1,33.5,30.1s-0.3,76.1,0.8,95.3c1.1,19.2,40.8,81.8,40.8,81.8l37.2-33.1 c0,0-28.9-48.3-30.8-59.6c-2-11.4,10.5-71,10.5-95.3c0-4.5-0.4-9.1-1.1-13.7c-1.5-10.1-4.2-20-6.6-27.4 c-2.4-7.3-4.4-12.2-4.4-12.2s-20.2,2.9-40.4,8.6c-18.5,5.2-36.9,12.6-39.7,22.1C1183.2,833.5,1183.3,834.6,1183.7,835.9 L1183.7,835.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1183.7,835.9c9.8,5.8,20.1,10.9,30.7,15.3c0.7-1.8,1.3-3.5,2.2-5.3c0.9,2,1.9,4,3,6.7 c18.2-4.6,36.6-8.4,55-11.3c-1.5-10.1-4.2-20-6.6-27.4c-14.9-1.4-29.9-2.6-44.8-3.6c-18.5,5.2-36.9,12.6-39.7,22.1 C1183.2,833.5,1183.3,834.6,1183.7,835.9L1183.7,835.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M1287.1,710.9c-1.4-8.6-33.8-19.6-44.8-18.6c-23.7,2.2-40.8,6.5-46.2,9.8s-10.3,35-10.3,43.8 c0,10.4,3.6,30.9,2.6,39.1c-1.8,16-11.6,49.9-11.6,49.9l35.7,12.5l4.4-7.8l4,9.9l58.9-13.5c0,0-4.5-46.9-4.5-55.2 C1275.4,772.9,1288.9,721.9,1287.1,710.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M1232.1,716.4c-11.8,61.7-12.5,79.3-15.2,122.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1233.7,
    cy: 728.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1228.7,
    cy: 755.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1224.9,
    cy: 784.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 1222.9,
    cy: 816.7,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1163.3,754.6l5.9,0.5l0.5,0l39.6-10.4c2.7-1.4,3.2-3.7,2.5-5.5c-0.8-2.2-3.5-3.3-5.7-2.5l-37.8,13.3 l-0.4,0.3L1163.3,754.6L1163.3,754.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M1163.3,754.6l1.6,0.1l4.3,0.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.5-0.5-0.8-1.2-0.6-1.9 c0.1-0.3,0.3-0.6,0.1-0.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.3-0.8-0.2-1.2l-3.4,3.1L1163.3,754.6L1163.3,754.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1163.3,754.6l1.6,0.1c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.1-0.4-0.1-0.6L1163.3,754.6L1163.3,754.6z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1210.1,763.4c-3.9-7.2-7.8-14.4-11.9-21.7c-3.1-2.4-6.6-4.2-10.1-5.6c-4.2,1.4-8.2,3.9-11.5,7.3 c-0.8,0.8-1.6,2-1.3,3.2c0.3,0.8,1.1,1.2,1.9,1.2c0.8-0.1,1.5-0.5,2.2-0.9c2.2-1.3,4.3-2.5,6.8-3.7c0.7,0.6,1.4,1.2,1.9,1.8 c-1.5,0-2.9,0-4.7,0.5c-2.8,1.3-5.5,2.8-8.2,4.5c-0.7,0.5-1.6,1.1-1.6,2c-0.1,0.8,0.4,1.5,1,1.8s1.3,0.3,2,0.3 c2.5-0.2,5-1.1,7-2.6c0.8,0.2,1.7,0.5,2.3,0.9c-1.1,0.2-2.1,0.4-3.1,0.9s-1.9,1.3-2.3,2.5c-0.4,1.1-0.3,2.5,0.3,3.7 c-0.6,0.2-0.9,1-0.9,1.6s0.3,1.3,0.6,1.8c0.6,1.2,1.3,2.4,2,3.5c0.7,1,1.5,2.1,2.6,2.5c1.1,0.4,2.5,0.1,3.3-1.2 c2.9,5.1,8.4,8.1,13.8,7.5C1205.5,771.8,1208.2,767.8,1210.1,763.4L1210.1,763.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1193.1,745.8c-1.4-0.6-2.9-0.8-4.4-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1190.3,752c-1.4-0.1-2.8-0.1-3.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1181.1,759.1c2-1.1,5.3-1.7,7.5-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1187.9,767.4c-0.7-1.1-1.3-3-1.6-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1186.8,765.4c-0.9,0.1-1.8,0.3-2.6,0.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1199.9,773.4c0,0,49.3,41.8,62.6,37.1c5.3-1.9,10.5-17.2,14.3-31.5c3.5-13.1,5.8-25.4,5.8-25.4 l-27.9-11.8c0,0-1.9,12.7-3.8,23c-1.2,7-2.5,12.8-3.2,13c-2.8,0.8-39.1-15.3-39.1-15.3L1199.9,773.4L1199.9,773.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1251,764.8c6.7,4.4,17.1,10.8,25.9,14.2c3.5-13.1,5.8-25.4,5.8-25.4l-27.9-11.8 C1254.7,741.8,1252.9,754.5,1251,764.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M1282.7,768.5c-12.2-2.3-21.9-4.3-33.6-8.5c1.7-13.7,5.5-38.5,8.7-46.2c2.2-5.4,11-15,20.8-10.8 s13.6,10.6,12.6,27.8C1290.8,736.9,1285,756.1,1282.7,768.5L1282.7,768.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1223.1,698.5c0,0,2.9,13,8.4,16.8c5.5,3.8,26.5-19.5,26.5-19.5c-3.6-3.4-4.5-10-4.4-15.8 c0-6,1-11.1,1-11.1l-25.5,7.4c0.3,6.3-0.3,10.9-1.1,14.1C1226.2,697.4,1223.1,698.5,1223.1,698.5L1223.1,698.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1228,690.4c11.8,2.5,20.8-5,25.5-10.4c0-6,1-11.1,1-11.1l-25.5,7.4 C1229.3,682.6,1228.8,687.1,1228,690.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1232.4,715.8c-0.3-0.1,1.3-8.8,2.1-9.6c0.8-0.8,21-18.4,22.2-17.7c1.8,0.9,4.7,6.5,4.7,6.5 s-4.1,5.6-11.9,11.9C1244.1,711.3,1235.5,716.3,1232.4,715.8L1232.4,715.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1232.4,715.7c0.4-0.4-0.5-9.1-1-9.9c-1.7-2.6-4.5-9.5-4.5-14.2c0,0-5.1,1.9-5.7,3 c-0.6,1.1,2.1,9.4,4.3,13.3C1229.1,714.5,1232.1,716.1,1232.4,715.7L1232.4,715.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1127 -0.9936 0.9936 0.1127 419.9187 1782.8652)",
    className: "st60",
    cx: 1208.2,
    cy: 656.3,
    rx: 7.8,
    ry: 10.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1268.6,644c0-20.1-13.9-36.4-31.1-36.4s-31.1,16.3-31.1,36.4s8.6,40.1,26,39.4 C1249.6,682.7,1268.6,664.1,1268.6,644z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1261.7,652.7c-3.6-3.9-5.9-11.3-6.4-14.5c-3.5-1-7.6-4.3-9.7-8.8c-5.3,5.3-25.3,8.2-31.9,6.5 c-4.8,5.9-4.9,8.8-6.6,16.3c-1.1-9.1-0.6-18.5,1.4-27.5c12.5-4,24.8-8.9,36.6-14.6c2-1,4.5-2,6.4-0.8 c1.2,0.7,1.9,2.1,2.5,3.4c2.7,5.5,6.5,10.4,11.2,14.2c1.2,1,2.6,2.2,2.7,3.7c0,1-0.5,2-1,2.9 C1264.6,637.7,1265,647.6,1261.7,652.7L1261.7,652.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1201.2,631.7c-0.1,7.6,6.1,23.4,6.1,23.4s0-13,6-21.5c12.3,0,25.9-0.6,33.4-7.6 c2.2,5.5,5.9,8.8,10.5,10.3c-0.1,6.9,3,13.4,5,19.2c3.9-2.3,6.8-1.4,9.9-5.1c1.8-6.8,3.8-17.3,3.2-23.8 c-0.5-5.2-1.9-10.6-4.7-15c-0.7-1.1-1.4-2.1-2.3-3c-4.4-4.9-11.3-7.7-17.7-6.1c-3.5-4.2-8.9-6.7-14.3-7 c-5.4-0.3-10.8,1.4-15.5,4.1c-9.2,5.2-16.4,13.3-18.8,24.6C1201.5,626.7,1201.3,629.1,1201.2,631.7L1201.2,631.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M1201.2,631.7c0.3-1,0.6-2,0.9-2.9c1.8-4.6,4.6-8.8,7.9-12.5c5-5.7,11.1-10.6,18.4-12.6 c7.3-2,15.7-0.7,21.1,4.5c6.8-2.9,15.2-1.3,21.1,3.5c-0.7-1.1-1.4-2.1-2.3-3c-4.4-4.9-11.3-7.7-17.7-6.1 c-3.5-4.2-8.9-6.7-14.3-7c-5.4-0.3-10.8,1.4-15.5,4.1c-9.2,5.2-16.4,13.3-18.8,24.6C1201.5,626.7,1201.2,629.2,1201.2,631.7 L1201.2,631.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1266.7,648.9c5.7-1.5,11.2,0.7,12.2,4.9c1.1,4.2-2.7,8.7-8.4,10.2c-5.7,1.5-11.2-0.7-12.2-4.9 C1257.3,654.9,1261.1,650.3,1266.7,648.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 1239.7,
    cy: 657.5,
    rx: 1.4,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 1214.8,
    cy: 657.5,
    rx: 1.4,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1218.8,644.4c-2.6-0.9-5.6-0.7-8,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1237.6,645.5c2.9-1.3,6.5-0.9,9.1,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M1224.1,659.2c-0.2,1.4-0.2,4.7,0,6.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M1225.6,671.3c3.8,1.5,7.7,0.7,9.8-2.4"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 1109,
    cy: 535.6,
    r: 52.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1135.7,509.3v35.9c0,8.8-4.4,16.9-11.8,21.8l-14.8,8.7l-13.6-8.8c-8.1-4.7-13.1-13.3-13.1-22.5v-34.9 l26.5-7.6l0.2,0.1L1135.7,509.3L1135.7,509.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M1135.7,509.3v35.9c0,8.8-4.4,16.9-11.8,21.8l-14.8,8.7v-73.8L1135.7,509.3L1135.7,509.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1102.9,
    y: 518.4,
    className: "st31",
    width: 12.3,
    height: 40.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 532.5,
    className: "st31",
    width: 40.6,
    height: 12.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialitiesSectionArt2);
export default __webpack_public_path__ + "static/media/specialities-section-art_2.791e77ecc37f6b8b40bd1203c62775b1.svg";
export { ForwardRef as ReactComponent };